import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.classes, "border-2 rounded-t-lg rounded-b-lg mt-2 z-20"])
  }, [
    _createElementVNode("div", {
      class: "w-full h-full z-20",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
    }, [
      _renderSlot(_ctx.$slots, "title")
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["rounded transform ease-in-out duration-700 transition-all z-0 h-full relative overflow-hidden w-full", _ctx.isAccordionOpen ? 'opacity-1' : 'opacity-0']),
      ref: "contentAccordion",
      style: _normalizeStyle(_ctx.isAccordionOpen ? _ctx.openClasses : 'max-height: 0')
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 6)
  ], 2))
}